interface Props {}
const LocalizedTextAndTwoButtons = (props: Props) => {
  const {} = props;
  return <div className=""></div>;
};

export default LocalizedTextAndTwoButtons;
